import { mapImpactCallouts } from '@websrc/DataMappers/mapSpot'
import React from 'react'

import Heading from '../Heading/Heading'
import { callouts as calloutsCss } from './ImpactCallouts.css'

type ImpactCalloutsProps = ReturnType<typeof mapImpactCallouts> & {
  isTopOfPage?: boolean
}

export const ImpactCallouts: React.FC<ImpactCalloutsProps> = ({ callouts, isTopOfPage }) => {
  return (
    <div className={calloutsCss._}>
      <div className={calloutsCss.list._}>
        {callouts.map((c) => {
          return (
            <div className={calloutsCss.list.item._} key={c.header}>
              <Heading
                headline={c.header}
                level={isTopOfPage ? 1 : 2}
                noSpacing={true}
                size={'xxl'}
                weight={'medium'}
              />
              <Heading
                headline={c.sub_header}
                level={isTopOfPage ? 2 : 3}
                noSpacing={true}
                size={'xs'}
                weight={'regular'}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
